import React from "react";
import Layout from "../Pages/Layout";
import Home from "../Pages/Home";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import AboutUs from "../Pages/AboutUs";
import ContactUs from "../Pages/ContactUs";
import Jobs from "../Pages/Jobs";
import SearchList from "../Pages/SearchList";

import CompanyProfile from "../Pages/CompanyProfile";
import ProfileScreen from "../Components/UserPanel/ProfileScreen";
import UserPanelSidebar from "../Components/UserPanel/UserPanelSidebar";
import Order from "../Pages/Order";
import OrderDetail from "../Pages/OrderDetail";
import { useSelector } from "react-redux";
import { selectSignedIn } from "../Redux/UserSlice";
import "animate.css";
import ForgotPassword from "../Pages/ForgotPassword";
import OrderChat from "../Components/UserPanel/OrderChat";
import Wallet from "../Components/UserPanel/Wallet";
import Dashboard from "../Components/UserPanel/Dashboard";
import History from "../Components/UserPanel/History";

function AppRouting() {
  const isSignedIn = useSelector(selectSignedIn);
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="about-us" element={<AboutUs />} />
            <Route path="contact-us" element={<ContactUs />} />
            <Route path="jobs" element={<Jobs />} />
            <Route
              path="forgotpassword/:id/:code"
              element={<ForgotPassword />}
            />
            <Route path="search" element={<SearchList />} />
            <Route path="company/:id" element={<CompanyProfile />} />

          </Route>
          {isSignedIn ? (
            <>
              <Route path="/user-profile/:id" element={<UserPanelSidebar />}>
                <Route index element={<Dashboard />} />
                <Route path="profile" element={<ProfileScreen />} />
                <Route path="orders" element={<Order />} />
                <Route path="wallet" element={<Wallet />} />
                <Route path="history" element={<History />} />
                <Route path="order-details/:id" element={<OrderDetail />} />
                <Route path="order-chat/:id" element={<OrderChat />} />
              </Route>
            </>
          ) : null}
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default AppRouting;
